<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline"> Reject Initiated Route </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-textarea
                outlined
                name="input-7-4"
                label="Remarks"
                value=""
                v-model="remarks"
                ></v-textarea>
              </v-container>
            </v-card-text>
            <h4 class="text-center red--text">
                {{errorMessage}}
            </h4>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="saveDocumentType"
                >Reject</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoadingOverlay from "../../common/LoadingOverlay.vue";
import Swal from "sweetalert2";
export default {
  name: "DocumentTypeModal",
  props: {
    dialog: Boolean,
    selected: Array, 
  },
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      remarks: ""
    };
  },
  methods: {
    ...mapActions(["rejectPendingDocuments", "fetchPendingInitiateDocuments"]),
    close() {
      this.remarks = "";
      this.$emit("closeDialog", `Close`);
    },
    async saveDocumentType() {
      if(this.remarks == ""){
          this.errorMessage = "Please provide a remark"
      }else{
          this.errorMessage = ""
          let body = []
          this.selected.forEach(item => {
              item.reject_remarks = this.remarks
              body.push({id: item.id, remarks: item.reject_remarks})
          })
          
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, reject it!",
            }).then((result) => {
        
            if (result.isConfirmed) {
                this.loading = true;
                this.rejectPendingDocuments(body).then((res) => {
                    if (res.error) {
                        this.loading = false
                        console.log(res.error)
                    } else {
                        this.fetchPendingInitiateDocuments().then(()=>{
                            this.loading = false
                            Swal.fire(
                            "Rejected!",
                            "Pending Document has been rejected.",
                            "success"
                            );
                            this.close()
                        });
                    }
                });
            }
        });
      }
    }
  },
};
</script>

<style>
</style>